'use client';

import React from 'react';
import HeroSection from './HeroSection';
import ServicesOverview from './ServicesOverview';
import CaseStudies from './CaseStudies';
import ServiceTiers from './ServiceTiers';
import ExpertiseShowcase from './ExpertiseShowcase';
import InteractiveTools from './InteractiveTools';
import ResourcesLibrary from './ResourcesLibrary';
import CTASection from './CTASection';

const RegulatoryConsultancyInteractive = () => {
  return (
    <>
      <HeroSection />
      <ServicesOverview />
      <CaseStudies />
      <ServiceTiers />
      <ExpertiseShowcase />
      <InteractiveTools />
      <ResourcesLibrary />
      <CTASection />
    </>
  );
};

export default RegulatoryConsultancyInteractive;